module.exports = __webpack_public_path__ + "static/media/light_irancell_labz_header_logo.75c6d573.svg";